/*
 * Pokaz slajdów w hero strony Kontakt (sections/kontakt.liquid).
 * Zdjęcia w [data-pokaz] przenikają się co `data-odstep` sekund.
 * Zatrzymuje się, gdy karta jest w tle, i nie rusza się przy
 * prefers-reduced-motion (wtedy zostaje pierwsze zdjęcie).
 */
(function () {
  var pokazy = document.querySelectorAll('[data-pokaz]');
  if (!pokazy.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  pokazy.forEach(function (pokaz) {
    var slajdy = pokaz.querySelectorAll('.kontakt__slajd');
    if (slajdy.length < 2) return;
    var odstep = Math.max(2, Number(pokaz.dataset.odstep) || 5) * 1000;
    var aktywny = 0;
    var licznik = null;

    function dalej() {
      slajdy[aktywny].classList.remove('jest-aktywne');
      aktywny = (aktywny + 1) % slajdy.length;
      var nastepny = slajdy[aktywny];
      // kolejne zdjęcie ma być już pobrane, zanim zacznie się przenikanie
      nastepny.loading = 'eager';
      nastepny.classList.add('jest-aktywne');
      // dogrywamy zdjęcie za następnym, żeby przy jego kolei nie mrugnęło
      slajdy[(aktywny + 1) % slajdy.length].loading = 'eager';
    }

    function start() {
      if (licznik) return;
      licznik = setInterval(dalej, odstep);
    }

    function stop() {
      clearInterval(licznik);
      licznik = null;
    }

    document.addEventListener('visibilitychange', function () {
      document.hidden ? stop() : start();
    });

    slajdy[1].loading = 'eager';
    start();
  });
})();
